import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import RunTicketsDataService from "../../services/run-tickets-data-service/RunTicketsDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { UseRunTicketTanksReturnType } from "./Common";
import { keys } from "./Keys";

export type UseRunTicketTanksParameters = {
    customerID: number,
    groupID: number,
    contextObject: IeLynxObject
} & BaseUseQueryParameters<UseRunTicketTanksReturnType>;

export function useRunTicketTanks({
    customerID,
    groupID,
    contextObject,
    offline,    
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseRunTicketTanksParameters) {
    return useQuery<UseRunTicketTanksReturnType, RestError, UseRunTicketTanksReturnType>(
        keys.tankList(customerID, groupID, contextObject, offline ?? false),
        ({ signal }) => {
            return RunTicketsDataService.getRunTicketTanks(customerID, groupID, contextObject, offline ?? false, signal);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
